import type { Canvas } from 'fabric';

// Custom canvas event fired after the model repaints, so effect reconcilers can
// re-derive their overlays. Fabric's event types don't cover custom names, so the
// cast lives here (once). We cast the canvas — not the method — so `this` stays bound.
const MODEL_RENDERED = 'modelRendered';

type CustomEventCanvas = {
  fire(name: string): void;
  on(name: string, handler: () => void): void;
  off(name: string, handler: () => void): void;
};

export const fireModelRendered = (canvas: Canvas): void => {
  (canvas as unknown as CustomEventCanvas).fire(MODEL_RENDERED);
};

export const onModelRendered = (canvas: Canvas, handler: () => void): (() => void) => {
  const c = canvas as unknown as CustomEventCanvas;
  c.on(MODEL_RENDERED, handler);
  return () => c.off(MODEL_RENDERED, handler);
};
